define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var LE = require("app");

    var FILTER_ENUM = {
        NAME: "name"
    };

    var COMPARATORS_ENUM = {
        NAME: "name",
        USERS_COUNT: "usersCount",
        CAMPAIGNS_COUNT: "campaignsCount",
        SKILLS_COUNT: "skillsCount",
        CONTENTS_COUNT: "contentsCount"
    };

    var LobsGridModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        LobsGridModel = BaseModel.extend({
            defaults: {
                filters: {
                    "name": []
                },
                comparators: {
                    "name": "name",
                    "usersCount": "",
                    "campaignsCount": "",
                    "skillsCount": "",
                    "contentsCount": ""
                }
            },

            initialize: function () {
                var supportedTypes = LEUserManagement.getDataManager().getLobSupportedTypes();
                this.set("comparators." + COMPARATORS_ENUM.USERS_COUNT, "counts." + supportedTypes.USER);
                this.set("comparators." + COMPARATORS_ENUM.CAMPAIGNS_COUNT, "counts." + supportedTypes.CAMPAIGN);
                this.set("comparators." + COMPARATORS_ENUM.SKILLS_COUNT, "counts." + supportedTypes.SKILL);
                this.set("comparators." + COMPARATORS_ENUM.CONTENTS_COUNT, "counts." + supportedTypes.CANNED_RESPONSE);
            },

            pluck: function (_model) {
                return true;
            },

            setFilterValue: function (filterName, filterValue) {
                if (!_.isUndefined(this.get("filters." + filterName))) {
                    this.set("filters." + filterName, filterValue);
                }
            },

            getFilterValue: function (filterName) {
                return this.get("filters." + filterName);
            },

            predicate: function (model) {
                var modelIsInSelection = true;
                var passFilter;

                // if lob feature enabled - pre filter - filter always by user lobIds - no matter what is set in the filters attribute
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    passFilter = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, model.id);
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model name is in selection:
                var nameFilter = this.get("filters.name");
                if (!_.isEmpty(nameFilter)) {
                    passFilter = _.some(nameFilter, function (name) {
                        return model.getName() === name;
                    });

                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                return modelIsInSelection;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    LobsGridModel.FILTER_ENUM = FILTER_ENUM;

    return LobsGridModel;
});

